const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMicOff(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1327",
    d: "M713.833 31.343a6.007 6.007 0 0 0 6-6v-5.754a6 6 0 1 0-12 0v5.754a6.007 6.007 0 0 0 6 6zm-4-11.754a4 4 0 1 1 8 0v5.754a4 4 0 1 1-8 0z",
    style: {
      fill: "current"
    },
    transform: "translate(-695.833 -9.589)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1328",
    d: "M719.772 39.189h-4.939v-3.96c4.493-.438 8-3.785 8-7.84a1 1 0 0 0-2 0c0 3.249-3.141 5.892-7 5.892s-7-2.643-7-5.892a1 1 0 0 0-2 0c0 4.055 3.507 7.4 8 7.84v3.96h-5a1 1 0 0 0 0 2h11.939a1 1 0 0 0 0-2z",
    transform: "translate(-695.833 -9.189)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 318",
    transform: "translate(5.751 6.5)",
    style: {
      stroke: "#ff3e72",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "current"
    },
    d: "M24.499 0 0 24.5"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicOff);
export default __webpack_public_path__ + "static/media/icon-mic-off.8dac24580b3676e2b4b5bfc6f7c25fe1.svg";
export { ForwardRef as ReactComponent };